import { gql } from "@apollo/client"
export const RENEW_COMPANY_SUBSCRIPTION = gql(`
  mutation RenewCompanySubscription($input: RenewCompanySubscriptionInput!) {
    renewCompanySubscription(input: $input) {
      __typename
      companySubscription {
        id
      }
      errors {
        __typename
        ... on UnknownError {
          message
        }
        ... on ValidationError {
          errors {
            fieldName
            messages
          }
        },
        ... on EntityNotFoundError {
          message
        }
      }
    }
  }
`);

